import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class WwniSubCategoryService {

  constructor(private http: HttpClient) { }

  /**
   * Get sub category data
   * @param baseUrl - Base URL for the API
   * @param requestParams - Request parameters
   * @param globalService - Global service data
   * @param filterParams - Filter parameters
   * @param rowData - Row data
   * @returns Observable<any>
   */
  getSubCategoryData(
    baseUrl: string,
    requestParams: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService || {}, filterParams);
    
    // Add request specific parameters
    params = { ...params, ...requestParams };
    
    // Essential parameters with fallbacks
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250; // AngularJS factory fallback
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";

    const url = `${baseUrl}/loadJsonObject`;

    // CRITICAL: Use application/x-www-form-urlencoded Content-Type
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save WWNI details (if needed for future functionality)
   * @param baseUrl - Base URL for the API
   * @param formData - Form data to save
   * @param globalService - Global service data
   * @param filterParams - Filter parameters
   * @param rowData - Row data
   * @returns Observable<any>
   */
  saveWwniDetails(
    baseUrl: string,
    formData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService || {}, filterParams);
    
    // Essential parameters with fallbacks
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250; // AngularJS factory fallback
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";

    // Add form data
    params.jsonObj = JSON.stringify(formData);
    params.jsonSettings = JSON.stringify({}); // Empty settings as per original
    params.process_name = "SAVE_WWNI_DETAILS";

    // Include checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "cdr_number": rowData.CDR_NO,
      "consol_group_key": rowData.CONSOL_GROUP_KEY,
      "reporting_period": rowData.REPORTING_PERIOD,
      "combination_key": rowData.COMBINATION_KEY,
      "scenario_key": parseInt(filterParams.scenario || params.scenario)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    const url = `${baseUrl}/saveJsonObject?action_code=v3cjp3`;

    // CRITICAL: Use application/x-www-form-urlencoded Content-Type
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
